import { Box, Stack, styled } from '@mui/material'
import {
  facilityReservationSelectionCreateUrl,
  rootUrl,
} from '../../containers/common/constant/appUrl'
import { facilityReservationStep } from '../../containers/common/constant/classification'
import {
  dispMode,
  useAction,
} from '../../containers/facilityLotteryReservationCompletion/facilityLotteryReservationCompletionService'
import { translate } from '../../i18n'
import { AnnotationLabel } from '../components/common/annotationLabel'
import { AttentionLabel } from '../components/common/attentionLabel'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonL } from '../components/common/buttons/buttonL'
import { ButtonOutlinedResponsive } from '../components/common/buttons/buttonOutlinedResponsive'
import { CompletionMessageLabel } from '../components/common/completionMessageLabel'
import { CenterGItem, GContainer, GItem, RowSpacerGItem } from '../components/common/grids'
import { StepBar } from '../components/common/stepBar'

const StatementGItem = styled(GItem)({
  display: 'flex',
  justifyContent: 'center',
  margin: '38px',
})
const AnnotationBox = styled('div')({
  whiteSpace: 'pre-wrap',
  display: 'flex',
  justifyContent: 'center',
})

export const FacilityLotteryReservationCompletion = () => {
  const {
    facilityId,
    childId,
    displayMode,
    steps,
    announcementDatetime,
    year,
    month,
    date,
    hours,
    minutes,
    onClickShowReservationList
  } = useAction()

  return (
    <Stack spacing={2}>
      <GContainer>
        <GItem md={3}></GItem>
        <GItem xs={12} md={6}>
          <StepBar activeStepValue={facilityReservationStep.step4} stepValueLabels={steps} />

          <Box>
            <GContainer>
              <StatementGItem xs={12}>
                <CompletionMessageLabel>
                  {translate('facilityLotteryReservationCompletion.label.completion')}
                </CompletionMessageLabel>
              </StatementGItem>

              <GItem xs={1}></GItem>
              <GItem xs={10}>
                <GContainer>
                  <CenterGItem xs={12}>
                    <AttentionLabel>
                      {translate('facilityLotteryReservationCompletion.text.waitAnnouncement')}
                    </AttentionLabel>
                  </CenterGItem>
                  {announcementDatetime && (
                    <CenterGItem xs={12}>
                      <AttentionLabel>
                        {translate(
                          'facilityLotteryReservationCompletion.text.announcementDatetime',
                          year,
                          month,
                          date,
                          hours,
                          minutes
                        )}
                      </AttentionLabel>
                    </CenterGItem>
                  )}
                </GContainer>
                <RowSpacerGItem />
                <AnnotationBox>
                  <AnnotationLabel>{translate('facilityLotteryReservationCompletion.text.subMessage')}</AnnotationLabel>
                </AnnotationBox>
              </GItem>
              <GItem xs={1}></GItem>
            </GContainer>
          </Box>
        </GItem>
        <GItem md={3}></GItem>
      </GContainer>
      <BottomButtonGroup>
        {displayMode === dispMode.insert && (
          <ButtonL fullWidth to={facilityReservationSelectionCreateUrl.url(facilityId, childId)}>
            {translate('facilityLotteryReservationCompletion.button.nextReservation')}
          </ButtonL>
        )}
        <ButtonL fullWidth onClick={onClickShowReservationList}>
          {translate('facilityLotteryReservationCompletion.button.reserveStatusCheck')}
        </ButtonL>
        <ButtonOutlinedResponsive to={rootUrl.url()}>{translate('system.button.backToHome')}</ButtonOutlinedResponsive>
      </BottomButtonGroup>
    </Stack>
  )
}
